import cx from "classnames"
import type React from "react"
import type { IconColorsType } from "../Icon"
import capitalize from "../utils/capitalize"

type BaseColor =
  | "base"
  | "accent"
  | "warning"
  | "error"
  | "success"
  | "connect"
  | "keyExchange"
  | "disabled"
  | "info"
  | "driver"
  | "owner"
type WithBackgroundColor = `${BaseColor}Alt`

export type ContainedIconPropsType = {
  icon: React.JSX.Element
  color?: IconColorsType | BaseColor | WithBackgroundColor
  className?: string
}

export function ContainedIcon({
  icon,
  color = "base",
  className,
}: ContainedIconPropsType) {
  return (
    <div
      className={cx(
        className,
        `cobalt-contained-icon cobalt-contained-icon--color${capitalize(color)}`,
      )}
    >
      {icon}
    </div>
  )
}
